import http from '@/libs/http'

/*
	NOTICE:
	- every action starts with an underscore
*/

const actionsAdmin: any = {
	async _makeIntegretyCheck({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/integretycheck`, config)
			// console.log(resp)
			// return resp.data
			const resp = await http.getAuth<any>(`/api/v1/admin/integretycheck`)
			return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _breakComappBinaries({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/breakcomappbinaries`, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/breakcomappbinaries`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	// async _uploadZipFolderToDo({ dispatch }: any, data: any) {
	async _createCommappZip({ dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/admin/createcommappzip`, data, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.postAuth<any>(`/api/v1/admin/createcommappzip`, data)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _reinitNeDb({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/reinitnedb`, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/reinitnedb`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _forcecachecustomgraphs({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/forcecachecustomgraphs`, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/forcecachecustomgraphs`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _forcecachemoduls({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/forcecachemoduls`, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/forcecachemoduls`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _cleanStorage({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/cleanstorage`, config)
			// console.log(resp)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/cleanstorage`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _listSpace({ dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/admin/listspace `, config)
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/admin/listspace`)
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	// async _analyzeAlertData({ dispatch }: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/admin/analyzeAlertData`, config)
	// 		console.log(resp.data)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(await dispatch('_makeErrorMsg', error))
	// 	}
	// },
	// async _sendWarnAlertEmailTrigger({ dispatch }: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/admin/sendWarnAlertEmailTrigger`, config)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(await dispatch('_makeErrorMsg', error))
	// 	}
	// },

	async _listTempYoctos({ dispatch }: any) {
		try {
			// console.log('_listTempYoctos')
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/tempyoctos/list `, config)
			// console.log(resp)
			// await dispatch('_set', ['tempYoctos', resp.data])
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/tempyoctos/list`)
      await dispatch('_set', ['tempYoctos', resp])
      return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _sendYoctoFutureSet({ dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(
			// 	env.apiUrl + `/api/v1/tempyoctos/setfuturesettings/${data.id}`,
			// 	data.data,
			// 	config,
			// )
			// await dispatch('_set', ['tempYoctos', resp.data])
			// await dispatch('_listTempYoctos')
			// console.log(resp)
			// return resp.data
      const resp = await http.postAuth<any>(`/api/v1/tempyoctos/setfuturesettings/${data.id}`, data.data)
      await dispatch('_set', ['tempYoctos', resp])
      await dispatch('_listTempYoctos')
      return resp

		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},
}

export default actionsAdmin
